import { gql } from '__generated__';

export default gql(`
  mutation setRegistrationStatus($input: SetRegistrationStatusInput!) {
    setRegistrationStatus(input: $input) {
      id
    }
  }
`);
